import { render, staticRenderFns } from "./sendGoods.vue?vue&type=template&id=b6289fea&scoped=true&"
import script from "./sendGoods.vue?vue&type=script&lang=js&"
export * from "./sendGoods.vue?vue&type=script&lang=js&"
import style0 from "./sendGoods.vue?vue&type=style&index=0&id=b6289fea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6289fea",
  null
  
)

export default component.exports